import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PORTFOLIO_PROJECTS } from "@/data/portfolioProjects";

function mergeProject(cmsDoc, jsDoc) {
  if (!cmsDoc && !jsDoc) return null;
  if (!cmsDoc) return jsDoc;
  if (!jsDoc) return cmsDoc;
  const merged = { ...jsDoc, ...cmsDoc };
  if (!Array.isArray(cmsDoc.keyFeatures) || cmsDoc.keyFeatures.length === 0) {
    merged.keyFeatures = jsDoc.keyFeatures;
  }
  if (!Array.isArray(cmsDoc.categoryTags) || cmsDoc.categoryTags.length === 0) {
    merged.categoryTags = jsDoc.categoryTags;
  }
  ["shortDescription", "overview", "problem", "solution", "uiConcept", "expectedResult", "cardImage", "url", "tag", "title"].forEach((key) => {
    if (!String(cmsDoc[key] || "").trim()) merged[key] = jsDoc[key];
  });
  return merged;
}

function fetchPublicPortfolio() {
  return api.get("/public/portfolio", { timeout: 8000 }).then((res) => res.data?.items || []);
}

export function usePortfolioProjects() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetchPublicPortfolio()
      .then((next) => {
        if (!cancelled) setItems(Array.isArray(next) ? next : []);
      })
      .catch(() => {
        if (!cancelled) setItems([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { items, loading };
}

export function usePortfolioProject(slug) {
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(Boolean(slug));

  useEffect(() => {
    if (!slug) {
      setProject(null);
      setLoading(false);
      return undefined;
    }
    let cancelled = false;
    setLoading(true);
    setProject(null);
    fetchPublicPortfolio()
      .then((items) => {
        if (cancelled) return;
        setProject((items || []).find((row) => row.slug === slug) || null);
      })
      .catch(() => {
        if (!cancelled) setProject(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [slug]);

  return { project, loading };
}

export { PORTFOLIO_PROJECTS, mergeProject };
